import { ReactNode, useState } from 'react';
import { Box, ButtonBase, Collapse, SvgIcon, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ChevronDown } from '../../../assets';

interface AdvancedFiltersProps {
  children: ReactNode;
}

/**
 * Collapsible "Advanced filters" section for report forms. The common quick options (chips) stay
 * visible above it; the full set of dropdowns/date pickers lives inside, hidden by default.
 */
const AdvancedFilters = ({ children }: AdvancedFiltersProps) => {
  const { t } = useTranslation('common');
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  return (
    <Box sx={{ mt: '4px' }}>
      <ButtonBase
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          fontWeight: 500,
          fontSize: 'inherit',
          color: theme.palette.primary.main,
          userSelect: 'none',
          mb: open ? '12px' : 0,
        }}>
        {t('reportingV2.advanced-filters')}
        <SvgIcon sx={{ width: '16px', transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}>
          <ChevronDown />
        </SvgIcon>
      </ButtonBase>
      <Collapse in={open}
        timeout={200}
        unmountOnExit>
        <Box sx={{ pt: '4px' }}>
          {children}
        </Box>
      </Collapse>
    </Box>
  );
};

export default AdvancedFilters;
